import { Skeleton } from "@/components/ui/skeleton";

const PropertyCardSkeleton = () => {
  return (
    <div className="bg-card rounded-2xl overflow-hidden shadow-card">
      {/* Image */}
      <Skeleton className="aspect-[4/3] w-full" />
      
      {/* Content */}
      <div className="p-3.5 space-y-2">
        {/* Location & Rating */}
        <div className="flex items-center justify-between">
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-4 w-16" />
        </div>

        {/* Title */}
        <div className="space-y-1">
          <Skeleton className="h-5 w-full" />
          <Skeleton className="h-5 w-3/4" />
        </div>

        {/* Amenities */}
        <div className="flex items-center gap-3">
          <Skeleton className="h-4 w-10" />
          <Skeleton className="h-4 w-10" />
          <Skeleton className="h-4 w-10" />
        </div>

        {/* Price */}
        <div className="pt-2 border-t border-border">
          <Skeleton className="h-6 w-28" />
        </div>
      </div>
    </div>
  );
};

export default PropertyCardSkeleton;
